module.exports = __webpack_public_path__ + "img/9.e1e32888.jpg";